import { ButtonComponent } from '../Button'
import { FieldTextComponent } from '../FieldText'
import { FormSectionComponent } from '../FormSection'

import { useSimpleState } from '../../hooks/useSimpleState'

import './index.css'

const CategoryFormComponent = ({ value={}, config={}, events={} }) => {
    const {_state} = useSimpleState({
        name: value.name || ''
    })

    const handleSubmit = () => {
        let body = _state.get()

        if (config.actionType === 'edit')
            body.id = value.id

        if (events.handleSubmit)
            events.handleSubmit(body)
    }

    return (
        <div className="c-CategoryForm">
            <FormSectionComponent config={{ title: 'Category Details' }}>
                <div className="form-fields">
                    <FieldTextComponent
                        value={_state.get('name')}
                        config={{ name: 'name', label: 'Name', errors: config.errors }}
                        events={{ handleChange: (val) => _state.set('name', val) }}
                    />
                </div>
            </FormSectionComponent>

            <div className="form-controls">
                <ButtonComponent events={{ handleClick: handleSubmit }}>
                    {config.actionType === 'edit' ? 'Save Changes' : 'Create'}
                </ButtonComponent>
            </div>
        </div>
    )
}

export { CategoryFormComponent }
